var _rule = require("../rule.js");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _rule2.default.makeRule({
    name: "math-empty",
    severity: _rule2.default.Severity.WARNING,
    selector: "math, blockMath",
    pattern: /^$/,
    message: "Empty math: don't use $$ in your markdown."
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/gorgon/rules/math-empty.js
 ** module id = 225
 ** module chunks = 0 2
 **/